import { render, staticRenderFns } from "./NewProductTile.vue?vue&type=template&id=14618245&scoped=true&"
import script from "./NewProductTile.vue?vue&type=script&lang=js&"
export * from "./NewProductTile.vue?vue&type=script&lang=js&"
import style0 from "./NewProductTile.vue?vue&type=style&index=0&id=14618245&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14618245",
  null
  
)

export default component.exports